import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthContext } from '_technical/contexts/AuthContext';

function AuthGuard(props: any) {
  const { children } = props;

  const { auth } = useAuthContext();
  if (!auth?.token) {
    return <Redirect to="/connexion" />;
  }

  return children;
}

export default AuthGuard;
